module.exports = __webpack_public_path__ + "img/3.f27d6727.jpg";